// extracted by mini-css-extract-plugin
export default {"wrapper":"LineOrTitle_wrapper__XYjxU","icon":"LineOrTitle_icon__m1D5v","active":"LineOrTitle_active__9SVSu"};